import { createColDef } from '@fortem-monorepo/react-ag'

import { InvestmentBucketIdCellEditor } from '@/ag-grid/columns/investment-bucket-id/cell-editor'
import { InvestmentBucketIdCellRenderer } from '@/ag-grid/columns/investment-bucket-id/renderer'

export const investment_bucket_id = createColDef({
  field: 'investment_bucket_id',
  headerName: 'Investment Bucket',
  cellRenderer: InvestmentBucketIdCellRenderer,
  cellEditor: InvestmentBucketIdCellEditor,
  width: 100,
})
